<template>
  <div class="section1" style="height: 100%">
    <div class="logImg">
      <img :src="loginImageBase64" alt="" />
    </div>
    <div class="blueline"></div>
    <div class="group1">
      <div class="itemall" id="step1">
        <div class="item1">
          <div class="logo"></div>
          <div style="text-align: center">
            <img src="../../assets/images/logo.png" />
          </div>
          <!-- <div class="txt"></div> -->
        </div>
        <div class="item2">
          <div class="ipt1">
            <div class="bg1">
              <img
                src="data:image/png;base64,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"
              />
            </div>
            <input id="username" type="text" placeholder="用户名" autocomplete="off" />
          </div>
          <div class="ipt2">
            <div class="bg2">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAFpOLgnAAAAAXNSR0IArs4c6QAABMBJREFUaAXtGU2IU0d45iVGWuthV+2axBbEg9BLDy6oJ5tuEwvSYpJTPSmlvQjtQRQL/qNoxUIpUiq0gojQyyasoKXZtSniQbSngoey0IpLsuqqFLHV3WTf9Pvifo+Zycx7yauBIO/B7vcz3/83b2behDHpGa3UJiWSOUTAgOCM/YaQeN4gMgq59EeM8R9IAIQZIwJxeoq5NFc0aYBg+EGywKpVES9ValeI0TJZGq+dfdSoNyDKDUpgMkG4NXxrdN0PtHxQiAjJuczjjJ8r5FLbiacokUJikC/5YDj1LwqVxuuuENgsfrWYS21CnqdECsi0PZyzh4Vserk1IZOiEGwZ8rtSIkOhlLycyArC0kT9a+ayHTzGs/mR5A15TFG4PCkWP/2r/kwWQBxnJ/GUsGRhzvkJEpIrGiemDCWLX8jCKON5GPtlZq2sZMNbsZUr07tc5p6yCRHfe9M6ESYlLyRiBMGXSIG7QcnSuDdHiGGCo5X6fcbECtMY8mLM2bI1l7xsG/d1ok8lmxGPH+OF4kiq7NELiNWJ7gAmvShkU0q7yxO1Pa7LvpSNOtzJ5LPJXxWeTBA+Wn24inCCugPk599Ln4QofyQZhDCj28qmREbCceEuITwICsb/UWQEe0WhgVDKpZdIF+6WpqXCmEm3xoLkIydBFVLGX55yKVNYyVEjSlfuvivm3YPAXgd/U3BsK8Gmug9XAk20jQx0AkvHx7B0fN+mSQzO/yxmU2uINEFfJ3AOqsI56B2Tos6jF0/nI21tPC5+nTpAQ36rhdWJvrqiITig/Q3/jgK8iLT+QOZ7dR7SxuNJeaL+qetq/YS9oqDtFXr0kPlxsOmdg8ihMRM4HR4hAYR4xDRtRs4iZ7UsZ8MtTsSQrAA5nZZpwvOZ5G3C/aDRia7gcNY6det8Ew0la5uxHTkxGeuGp3jVG9mNIV3WiTnr6Zjds0yE654nxz1zQg4QRk7kagTiUbkCSyQLROWSqxGIR+UKLBHsp/MkpCz1xAwDx67NLG0+ndsFR73PYCcd6MgGZzXo14k3BlJnhoc53LSFf/5XIrduicQf9enTsON+Ej6E55oLp9398Gl6LIyt0ImMjtcvMCG2hXEapAMf6YfgI/1wkJw83nUiY5WZ1DxrTAomXpUNvXCc8zuD8eTaTIa33eeZfBnPwSZB5I1N3Btquo0puMgJXIpgqnw3EI/vzmRefyLbu1S9v3K22TgDx+APZX4bLsSbjxrTd2DaJsGW91K3yS0wuuoIfBX8BIbftxlDPpxmv81n0zv9ZHAMT7Ll8emfobNZP1m4vP4GLq8/95PBscDKkgG82Icq5og2QajchU6SQF18uSHAHMCbJlsej7MtHu6DdJzIY/EAPm39pxTE9ruPL+MQFMdXBzq3BrtnVJaYHSci6fQl6pspXkEm2OxrGHnT5avd+fZrRSUrh3+ViPlcWijCz4m5JjsKL0zRMOSxYPq9tSjOWl/hiUFnavPbK9WbSJC0JgIv9mNo6VLPWh8h8KF/HX5L2iiHZJ1a/ZrEQvCDchKIWxPRBfudjhLptw5FHYk60qMKRFOrR4UNbTbqSOjS9Ugx6kiPChvarE9HOPwOpf1wH9rNC1TkbNLhsQO6xf8A6ox0gWrDhLcAAAAASUVORK5CYII="
              />
            </div>
            <input @onchange="changeValue()" id="password" type="password" placeholder="密码" />
          </div>
        </div>
        <div class="flex justBetween alignCenter">
          <label class="remmberPassworld"
            ><input class="mr5" id="check" @onchange="check()" type="checkbox" name="" />记住密码</label
          >
          <a @click="toStep2()" class="wPassWord mr20">忘记密码？</a>
        </div>
        <div class="item3 mt30">
          <el-button id="login" class="btn" :loading="loading" type="primary">登 录</el-button>
        </div>
        <div class="copyright">
          <p></p>
        </div>
      </div>
      <div class="itemall hide" id="step2">
        <div class="stepTitle">
          <h2>找回密码</h2>
          <p id="phoneText" class="mt10">输入手机号</p>
          <p id="noteText" class="mt10 hide">输入短信验证码</p>
        </div>
        <div class="item2">
          <div class="ipt1 step2Input">
            <input
              id="iphoneInput"
              @onkeyup="echarValue()"
              @onblur="chartPhone()"
              type="text"
              placeholder="请输入注册手机号"
              autocomplete="off"
            />
            <p id="iphoneErr" class="errWrong hide">手机号不存在</p>
            <img
              id="closeValue"
              @click="clearValue()"
              class="closeValue hide"
              src="../../assets/images/closeValue.png"
            />
          </div>
          <div class="ipt2 step2Input2">
            <input @onblur="chartYzm()" id="yzmValue" type="text" placeholder="请输入验证码" />
            <p id="yzmErr" class="errWrong hide">验证码错误</p>
            <img id="imgObj" class="loginYzm" alt="captcha" @click="changeImg()" />
          </div>
          <div class="ipt2 step2Input2 hide" id="noteYzm">
            <input id="dxInput" type="text" placeholder="请输入短信验证码" />
            <p id="dxYzm" class="errWrong hide">短信验证码错误</p>
            <button id="faYzm" class="faYzm" @click="someCode()">发送验证码</button>
          </div>
        </div>
        <div class="item3 mt10">
          <a @click="toStep3()" href="javascript:;">下一步</a>
        </div>
        <div class="copyright">
          <a @click="backLogin()">返回登录</a>
        </div>
      </div>
      <div class="itemall hide" id="step3">
        <div class="stepTitle">
          <h2>找回密码</h2>
          <p class="mt10">重置密码</p>
        </div>
        <div class="item2">
          <div class="ipt1 step2Input">
            <input
              @onkeyup="this.value = this.value.replace(/^ +| +$/g, '')"
              id="passVal1"
              type="password"
              placeholder="新密码"
              autocomplete="off"
            />
            <p id="passValText1" class="errWrong hide">密码不能小于8位</p>
          </div>
          <div class="ipt1 step2Input">
            <input
              @keyup="this.value = this.value.replace(/^ +| +$/g, '')"
              id="passVal2"
              type="password"
              placeholder="再次输入新密码"
              autocomplete="off"
            />
            <p id="passValText2" class="errWrong hide">两次输入的密码不一致</p>
          </div>
        </div>
        <div class="item3 mt10">
          <a onclick="toStep4()" href="javascript:;">下一步</a>
        </div>
        <div class="copyright">
          <a onclick="backLogin()">返回登录</a>
        </div>
      </div>
      <div class="itemall hide" id="step4">
        <div class="stepTitle">
          <h2>找回密码</h2>
          <p class="mt10">完成</p>
        </div>
        <div class="successDone">
          <div class="imgTip"></div>
          <p class="mt10">密码修改成功</p>
        </div>
        <div class="item3 mt10">
          <a @click="backLogin()" href="javascript:;">确定</a>
        </div>
      </div>
    </div>

    <div class="dialog" id="dialog" style="display: none">
      <div class="pop"></div>
      <div class="popDiv">
        <div class="title">提示</div>
        <div class="popContent" id="msg">提示test</div>
        <div class="popBtn">
          <button @click="closePop()">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { loginImageBase64 } from 'src/assets/base64'

var httpUrl = '/newretail'

export default {
  data() {
    return {
      loginFlag: true,
      checkedIsTrue: undefined,

      noChange: undefined,

      phoneIsTrue: undefined,
      yzmIsTrue: undefined,
      countdown: 60,
      loginImageBase64,
      loading: false,
    }
  },
  mounted() {
    if (localStorage.getItem('user') && localStorage.getItem('oldP')) {
      var userArr = JSON.parse(localStorage.getItem('user'))
      var oldP = JSON.parse(localStorage.getItem('oldP'))
      if (userArr[userArr.length - 1].isTrue == true) {
        $('#username').val(userArr[userArr.length - 1].username)
        $('#password').val(oldP.secpwd.substr(-8))
        $('#check').prop('checked', userArr[userArr.length - 1].isTrue)
      }
    }

    $('#login').on('click', () => {
      this.check()
      if (this.loginFlag) {
        this.loginFlag = false
        var loginData
        if (localStorage.getItem('user') && localStorage.getItem('oldP')) {
          var userArr = JSON.parse(localStorage.getItem('user'))
          var oldP = JSON.parse(localStorage.getItem('oldP'))
          if (oldP.secpwd.substr(-8) == $('#password').val() && userArr[userArr.length - 1].isTrue != undefined) {
            loginData = {
              username: $('#username').val(),
              password: '',
              secpwd: oldP.secpwd,
              isTrue: this.checkedIsTrue,
            }
          } else {
            loginData = {
              username: $('#username').val(),
              password: $('#password').val(),
              secpwd: '',
              isTrue: this.checkedIsTrue,
            }
          }
        } else {
          loginData = {
            username: $('#username').val(),
            password: $('#password').val(),
            secpwd: '',
            isTrue: this.checkedIsTrue,
          }
        }
        loginData.plat = 'nrcp'
        this.loading = true
        $.ajax({
          type: 'post',
          xhrFields: {
            withCredentials: true,
          },
          timeout: 7000,
          url: httpUrl + '/api/auth/login',
          data: JSON.stringify(loginData),
          contentType: 'application/json; charset=utf-8',
        })
          .done((data) => {
            if (typeof data.status != undefined && data.status == 0) {
              var userInfo = {
                uid: data.data.uid,
                token: data.data.token,
              }
              var mdPass = {
                secpwd: data.data.secpwd,
              }
              var userArr = new Array()
              var _useArr = {
                username: loginData.username,
                isTrue: loginData.isTrue,
              }
              var userRole = {
                role: data.data.role,
              }
              userArr.push(_useArr)
              localStorage.setItem('user', JSON.stringify(userArr))
              localStorage.setItem('oldP', JSON.stringify(mdPass))
              localStorage.setItem('headerData', JSON.stringify(userInfo))
              localStorage.setItem('role', JSON.stringify(userRole))
              localStorage.setItem('accessToken', data.data.accessToken)
              localStorage.setItem('refreshToken', data.data.refreshToken)
              sessionStorage.clear()

              const loginUser = {
                username: loginData.username,
              }
              localStorage.setItem('USER_INFO', JSON.stringify(loginUser))
              this.$store.dispatch('user/update', loginUser)

              this.$router.push({ name: 'retail-traffic' })
            } else {
              $('#dialog').show()
              $('#msg').html(data.msg)
            }
          })
          .fail(function () {
            alert('服务器未响应,请稍后重新提交')
          })
          .always(() => {
            this.loginFlag = true
            this.loading = false
          })
      }
    })

    $(document).on('keyup', function (ev) {
      if (ev.keyCode == 13) {
        $('#login').trigger('click')
      }
    })

    this.addSrc()
  },
  methods: {
    addSrc() {
      $('#imgObj').attr('src', httpUrl + '/api/captcha?')
    },
    check() {
      var checkedTrue = $('#check').prop('checked')
      if (checkedTrue) {
        this.checkedIsTrue = true
        $('#check').prop('checked', this.checkedIsTrue)
      } else {
        this.checkedIsTrue = false
        $('#check').prop('checked', this.checkedIsTrue)
      }
    },
    myAPI(data, url) {
      var promise = new Promise(function (resolve, reject) {
        $.ajax({
          contentType: 'application/json; charset=utf-8',
          xhrFields: {
            withCredentials: true,
          },
          type: 'post',
          url: url,
          data: JSON.stringify(data), //
        }).done(function (res) {
          if (res) {
            resolve(res)
          } else {
            reject(res)
          }
        })
      })
      return promise
    },
    changeValue(val) {
      if (val) {
        this.noChange = true
      }
    },
    closePop() {
      $('#dialog').hide()
    },
    //图形验证码
    changeImg() {
      var imgSrc = $('#imgObj')
      var src = imgSrc.attr('src')
      imgSrc.attr('src', this.changeUrl(src))
    },

    changeUrl(url) {
      var timestamp = new Date().valueOf()
      var index = url.indexOf('?')
      if (index > 0) {
        url = url.substring(0, index)
      }
      if (url.indexOf('&') >= 0) {
        url = url + '&timestamp=' + timestamp
      } else {
        url = url + '?timestamp=' + timestamp
      }
      return url
    },

    chartPhone(val) {
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(val)) {
        return $('#iphoneErr').show().html('手机号格式错误')
      } else {
        $('#iphoneErr').hide()
      }
      var url = httpUrl + '/api/auth/hasMobileUser'
      var mobile = {
        mobile: val,
      }
      if (val) {
        this.myAPI(mobile, url).then(function (res) {
          if (res.status == 0) {
            if (res.data) {
              this.phoneIsTrue = true
              $('#iphoneErr').hide()
              if (this.countdown == 60) {
                $('#faYzm').removeClass('disabled')
              }
            } else {
              this.phoneIsTrue = false
              $('#iphoneErr').show().html(res.msg)
              if (!$('#faYzm').hasClass('disabled')) {
                $('#faYzm').addClass('disabled')
              }
            }
          } else {
            this.phoneIsTrue = false
            if (!$('#faYzm').hasClass('disabled')) {
              $('#faYzm').addClass('disabled')
            }
            $('#iphoneErr').show().html(res.msg)
          }
        })
      } else {
        if (!$('#faYzm').hasClass('disabled')) {
          $('#faYzm').addClass('disabled')
        }
        $('#iphoneErr').show().html('手机号不能为空！')
        return false
      }
    },
    chartYzm(val) {
      var yzm = {
        captcha: val,
      }
      if (val) {
        $.ajax({
          async: false,
          type: 'post',
          xhrFields: {
            withCredentials: true,
          },
          url: httpUrl + '/api/checkCaptcha',
          data: JSON.stringify(yzm),
          contentType: 'application/json; charset=utf-8',
          success: (res) => {
            if (res.status == 0) {
              this.yzmIsTrue = res.data
              if (res.data) {
                if (this.countdown == 60) {
                  $('#faYzm').removeClass('disabled')
                }
                $('#yzmErr').hide()
              } else {
                if (!$('#faYzm').hasClass('disabled')) {
                  $('#faYzm').addClass('disabled')
                }
                $('#yzmErr').show().html('验证码错误！')
              }
            }
          },
        })
      } else {
        $('#yzmErr').show().html('验证码不能为空！')
        return false
      }
    },
    echarValue(val) {
      val ? $('#closeValue').show() : $('#closeValue').hide()
    },
    clearValue() {
      if ($('#iphoneInput').val) {
        $('#iphoneInput').val('')
        $('#closeValue').hide()
      } else {
        return false
      }
    },
    toStep2() {
      $('#iphoneInput').val('')
      $('#yzmValue').val('')
      $('#dxInput').val('')
      this.phoneIsTrue = false
      $('#step1').hide()
      $('#step2').show()
    },

    settime(val) {
      if (this.countdown == 0) {
        val.removeAttribute('disabled')
        val.className = 'faYzm'
        val.innerHTML = '发送验证码'
        this.countdown = 60
        return
      } else {
        val.setAttribute('disabled', true)
        val.className = 'faYzm disabled'
        val.innerHTML = '重新发送(' + this.countdown + ')'
        this.countdown--
      }
      this.settimeout(() => {
        this.settime(val)
      }, 1000)
    },

    //验证验证码
    modeCode() {
      var modeCode = {
        mobile: $('#iphoneInput').val(),
        captcha: $('#yzmValue').val(),
      }
      $.ajax({
        type: 'post',
        xhrFields: {
          withCredentials: true,
        },
        url: httpUrl + '/api/auth/sendMobileCode',
        data: JSON.stringify(modeCode),
        contentType: 'application/json; charset=utf-8',
      })
        .done(function (data) {
          if (status == 0) {
            if (data.data) {
              console.log(data.data)
            }
          }
        })
        .fail(function () {
          alert('服务器未响应,请稍后重新提交')
        })
        .always(function () {})
    },

    someCode() {
      this.chartYzm($('#yzmValue').val())
      if (this.yzmIsTrue == true) {
        if (this.phoneIsTrue == true && $('#iphoneInput').val() != '' && $('#yzmValue').val() != '') {
          var faYzm = document.getElementById('faYzm')
          this.settime(faYzm)
          this.modeCode()
        } else {
          if (!$('#faYzm').hasClass('disabled')) {
            $('#faYzm').addClass('disabled')
          }
        }
      }
    },

    toStep3() {
      this.chartYzm($('#yzmValue').val())
      //if(this.phoneIsTrue == true){
      if (this.phoneIsTrue == true) {
        $('#noteYzm').show()
        $('#noteText').show()
        $('#phoneText').hide()
        if ($('#dxInput').val() != '') {
          var edata = {
            mobile: $('#iphoneInput').val(),
            smscode: $('#dxInput').val(),
          }
          $.ajax({
            type: 'post',
            xhrFields: {
              withCredentials: true,
            },
            url: httpUrl + '/api/auth/checkMobileCode',
            data: JSON.stringify(edata),
            contentType: 'application/json; charset=utf-8',
          })
            .done(function (data) {
              if (status == 0) {
                if (data.data) {
                  $('#step2').hide()
                  $('#step3').show()
                  localStorage.setItem('newPass', JSON.stringify(edata))
                }
                data.data ? $('#dxYzm').hide() : $('#dxYzm').show()
              }
            })
            .fail(function (data) {
              alert('服务器未响应,请稍后重新提交')
            })
            .always(function () {})
        }
      } else {
        if ($('#iphoneInput').val() == '') {
          $('#iphoneErr').show().html('手机号不能为空！')
        }
      }
    },

    toStep4() {
      $('#passVal1').val()
      $('#passVal2').val()
      if ($('#passVal1').val().length < 8) {
        $('#passValText1').show()
      } else {
        $('#passValText1').hide()
      }
      if ($('#passVal1').val() == $('#passVal2').val()) {
        $('#passValText2').hide()
      } else {
        $('#passValText2').show()
      }
      if ($('#passVal1').val().length >= 8 && $('#passVal1').val() == $('#passVal2').val()) {
        var newPass = JSON.parse(localStorage.getItem('newPass'))
        console.log(newPass)
        var data = {
          mobile: newPass.mobile,
          smscode: newPass.smscode,
          newpwd: $('#passVal1').val(),
        }
        $.ajax({
          async: false,
          type: 'post',
          xhrFields: {
            withCredentials: true,
          },
          url: httpUrl + '/api/auth/changePwd',
          data: JSON.stringify(data),
          contentType: 'application/json; charset=utf-8',
          success: function (res) {
            if (status == 0) {
              if (res.data) {
                $('#step3').hide()
                $('#step4').show()
              }
            }
          },
        })
      }
    },

    backLogin() {
      $('#step1').show()
      $('#step2').hide()
      $('#step3').hide()
      $('#step4').hide()
      window.location.reload()
    },
  },
}
</script>

<style lang="less" scoped>
.section1 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #2c3962;
}
.section1 .group1 {
}
.section1 .group1 .item1 {
  padding-top: 20px;
  padding-bottom: 40px;
}
.input {
  background-color: #ffffff;
}
.section1 .group1 .logo {
  background: url(data:image/png;base64,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)
    no-repeat center;
  height: 64px;
  margin-bottom: 15px;
}
.section1 .group1 .txt {
  background: url(data:image/png;base64,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)
    no-repeat center;
  height: 24px;
}
.section1 .group1 .item2 {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.remmberPassworld {
  font-size: 14px;
  color: #2e3b66;
  padding-left: 50px;
  display: flex;
  align-items: center;
}
.section1 .group1 .item2 input {
  position: absolute;
  left: 0;
  top: 0;
  color: #ffffff;
  width: 236px;
  height: 42px;
  line-height: 42px;
  padding: 0px 35px;
  border-bottom: 1px solid #ccd8ff;
  color: #000;
}
.section1 .group1 .item2 input::placeholder {
  color: #ffffff;
}
.section1 .group1 .ipt1 {
  margin-bottom: 30px;
  position: relative;
  left: 0;
  top: 0;
  border: 1px solid #fff;
  width: 298px;
  height: 42px;
  border-radius: 4px;
}
.section1 .group1 .ipt2 {
  position: relative;
  left: 0;
  top: 0;
  border: 1px solid #fff;
  width: 298px;
  height: 42px;
  border-radius: 4px;
}
.section1 .group1 .bg1 {
  height: 23px;
  width: 25px;
  position: absolute;
  z-index: 99;
  top: 10px;
  left: 4px;
}
.section1 .group1 .bg2 {
  height: 23px;
  width: 25px;
  position: absolute;
  z-index: 99;
  top: 12px;
  left: 4px;
}
.section1 .group1 .bg1 img,
.section1 .group1 .bg2 img {
  height: 23px;
  width: 25px;
}
.section1 .group1 .item3 {
  display: flex;
  justify-content: center;
}
.section1 .group1 .item3 .btn {
  width: 280px;
  height: 50px;
  background: #5c76cc;
  font-size: 20px;
}
.section1 .copyright p {
  text-align: center;
  color: #fff;
  line-height: 24px;
  opacity: 0.6;
}
.group1 {
  display: flex;
  justify-content: flex-start;
}
.itemall {
  min-height: 429px;
  width: 380px;
  background: #ffffff;
  border-radius: 4px;
}
.wPassWord {
  font-size: 14px;
  color: #5c76cc;
  cursor: pointer;
}
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
input[type='text']:focus,
input[type='password']:focus,
textarea:focus {
  -webkit-box-shadow: 0 0 0 1000px white inset;
}
.logImg img {
  -webkit-transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -ms-transform: scaleX(-1);
  transform: scaleX(-1);
}
.blueline {
  height: 408px;
  min-width: 2px;
  background: url(data:image/png;base64,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)
    no-repeat center center; /* Safari 5.1 - 6.0 */
  background-size: 100%;
  margin: 0 100px;
}
/*placeholder*/
input[type='text']::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999 !important;
}
input[type='text']:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999 !important;
}
input[type='text']::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999 !important;
}
input[type='text']:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999 !important;
}
input[type='password']::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999 !important;
}
input[type='password']:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999 !important;
}
input[type='password']::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999 !important;
}
input[type='password']:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999 !important;
}

.hide {
  display: none;
}
.section1 .group1 .item2 .step2Input input,
.section1 .group1 .item2 .step2Input2 input {
  padding-left: 0;
  width: 271px;
}
.section1 .group1 .ipt2 {
  margin-bottom: 30px;
}
.section1 .group1 .item2 .step2Input2 input {
  padding-right: 135px;
  width: 171px;
}
.stepTitle {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 50px;
}
.stepTitle h2 {
  font-size: 26px;
  color: #2e3b66;
}
.stepTitle p {
  font-size: 16px;
  color: #2e3b66;
}
.copyright {
  text-align: center;
  margin-top: 36px;
  margin-bottom: 20px;
}
.copyright a {
  font-size: 14px;
  color: #5c76cc;
  cursor: pointer;
}
.errWrong {
  font-size: 14px;
  color: #ff2600;
  position: absolute;
  top: 46px;
  left: 0;
}
.closeValue {
  position: absolute;
  right: 0;
  top: 15px;
  cursor: pointer;
}
.loginYzm {
  position: absolute;
  right: 0;
  top: 6px;
  width: 100px;
  height: 34px;
  cursor: pointer;
}
.faYzm {
  font-size: 14px;
  color: #5c76cc;
  line-height: 12px;
  position: absolute;
  right: 0;
  top: 15px;
  cursor: pointer;
}
.successDone {
  text-align: center;
  margin: 4px 0 60px 0;
}
.imgTip {
  background: url(data:image/png;base64,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)
    no-repeat center center;
  width: 60px;
  height: 60px;
  margin: auto;
}
.successDone p {
  font-size: 16px;
  color: #2e3b66;
  font-weight: 550;
}
.disabled {
  font-size: 12px;
  color: #a8b0bf;
  cursor: default;
}

.dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}
.pop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.popDiv {
  width: 300px;
  height: 130px;
  padding: 10px;
  background: #fff;
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -115px 0 0 -150px;
  z-index: 12;
  box-shadow: 0 0 10px #333;
}
.title {
  padding: 0px 15px 10px;
  border-bottom: 1px solid #e6e6e6;
  font-size: 18px;
}
.popContent {
  font-size: 14px;
  max-height: 50px;
  height: 50px;
  line-height: 20px;
  padding-top: 10px;
  padding-left: 20px;
}
.popBtn {
  text-align: right;
}
.popBtn button {
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: #5c76cc;
  color: #fff;
  border: 1px solid #5c76cc;
  cursor: pointer;
  border-radius: 4px;
}
.logImg {
  width: 40%;
  max-width: 735px;
}
.logImg img {
  width: 100%;
}
.goOut ul {
  width: 280px;
  height: 192px;
  border: 1px solid #ccc;
  margin: 10px 50px;
  box-sizing: border-box;
  overflow-y: auto;
}
.goOut ul li {
  height: 36px;
  line-height: 36px;
  padding-left: 20px;
}
</style>